import { NgModule } from "@angular/core"
import { MatChipsModule } from "@angular/material/chips"
import { RouterModule } from "@angular/router"
import { BswalsComponent } from "@component/bswals/bswals.component"
import { WikiCreateComponent } from "@component/wiki-create/wiki-create.component"
import { WikiDetailComponent } from "@component/wiki-detail/wiki-detail.component"
import { WikiDisplayComponent } from "@component/wiki-display/wiki-display.component"
import { WikiListComponent } from "@component/wiki-list/wiki-list.component"
import { WikiComponent } from "@component/wiki/wiki.component"
import { EntityModule } from "./entity.module"
import { SharedModule } from "./shared.module"

@NgModule({
  declarations: [
    WikiComponent,
    WikiCreateComponent,
    WikiDetailComponent,
    WikiDisplayComponent,
    WikiListComponent,
    BswalsComponent
  ],
  imports: [
    SharedModule,

    RouterModule.forChild([
      {
        path: "",
        component: BswalsComponent
      },
      // {
      //   path: "",
      //   data: {
      //     title: 'Jobbörse'
      //   },
      //   component: WikiComponent
      // },
      // {
      //   path: "create",
      //   data: {
      //     title: 'Jobbörse'
      //   },
      //   component: WikiCreateComponent
      // },
      // {
      //   path: "edit/:id",
      //   data: {
      //     title: 'Jobbörse'
      //   },
      //   component: WikiCreateComponent
      // },

      /* The :name is pretty irrelevant when using stateservice.goto it's only necessary so that the slug later is written when the state is loaded for seo */
      // {
      //   path: "detail/:id/:name",
      //   component: WikiDetailComponent
      // },
    ]),

    EntityModule,

    MatChipsModule,
  ],
  exports: [
    SharedModule,

    MatChipsModule
  ]
})
export class WikiModule { }